/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Save_LabelInputs */



/**
* | output |
* | --- |
* | "Save Settings" |
*
* @param {Timing_Sync_Save_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_save_label = /** @type {((inputs?: Timing_Sync_Save_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Save_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les parametres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定を保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स सेव करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar configurações")
	return /** @type {LocalizedString} */ ("Save Settings")
});